import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Layer } from '@/model/document2/page/surface/design/layer/layer';

// レイヤーのプロパティ変更コマンド
export class ChangeLayerPropertyCommand implements ICommandBase
{
    private layer! : Layer;
    private propertyName! : string;
    private value! : any;
    private doneCallback! : () => void;

    private oldValue : any = 0;

    constructor(layer : Layer, propertyName : string, value : any, doneCallback : () => void)
    {
        this.layer = layer;
        this.propertyName = propertyName;
        this.value = value;
        this.doneCallback = doneCallback;

        // 現在の値を保持
        this.oldValue = layer[propertyName];
    }

    public do() : void
    {
        // プロパティに新しい値を設定
        this.layer[this.propertyName] = this.value;

        this.doneCallback();
    }

    public undo() : void
    {
        // プロパティに前の値を設定
        this.layer[this.propertyName] = this.oldValue;

        this.doneCallback();
    }

    public redo() : void
    {
        // プロパティに新しい値を設定
        this.layer[this.propertyName] = this.value;

        this.doneCallback();
    }
}